'use client'

import clsx from 'clsx'
import dynamic from 'next/dynamic'

import { useModalState } from '@/features/search/hooks/use-modal-state'
import { useSearchForm } from '@/features/search/hooks/use-search-form'
import { HeaderSearchForm } from '@/features/search/ui/header-search-form/header-search-form'

import { useHeaderSearch } from '@/entities/header-search'

import cl from './style.module.scss'

// Search results (product list, categories, history) render only after the user opens
// the search dropdown — load them on demand instead of on every page.
const HeaderSearchContent = dynamic(
	() => import('@/features/search/ui/header-search-content/header-search-content').then(m => m.HeaderSearchContent),
	{ ssr: false }
)

export const HeaderSearch = () => {
	const { value, dValue, onChange, reset, onSubmit } = useSearchForm()
	const { isOpen, open, close } = useModalState()
	const { haveData } = useHeaderSearch(dValue)
	return (
		<div className={cl.root} onMouseLeave={close} onClick={open}>
			<HeaderSearchForm value={value} onChange={onChange} onSubmit={onSubmit} onReset={reset} />
			{isOpen && haveData && (
				<div className={clsx(cl.wrapper)}>
					<HeaderSearchContent value={dValue} />
				</div>
			)}
		</div>
	)
}
